(function (w) {
  var SUPABASE_URL = 'https://ozddinkzagrabhjziczu.supabase.co';
  var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im96ZGRpbmt6YWdyYWJoanppY3p1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODUzMTI5OTksImV4cCI6MjEwMDg4ODk5OX0.T6IsiUcCtbAQMxEZY--FfnMtk76D-h8_fty1V-J_qjc';
  var FN_URL = SUPABASE_URL + '/functions/v1/yamato-sync';
  var REST_URL = SUPABASE_URL + '/rest/v1/buyback_messages';
  var POLL_MS = 120000; // 2分間隔（通常）。失敗時のみ短く再試行
  var pollTimer = null;
  var pollRequestId = null;
  var pollOnUpdated = null;
  var lastStatusKey = '';
  var tickBusy = false;
  var runPollTick = null;
  var failStreak = 0;

  function onTrackVisibility() {
    if (!document.hidden && typeof runPollTick === 'function') runPollTick();
  }

  if (typeof document !== 'undefined') {
    document.addEventListener('visibilitychange', onTrackVisibility);
  }

  function stripTags(html) {
    return String(html || '')
      .replace(/<script[\s\S]*?<\/script>/gi, ' ')
      .replace(/<style[\s\S]*?<\/style>/gi, ' ')
      .replace(/<[^>]+>/g, ' ')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isPendingStatus(mapped) {
    if (!mapped) return true;
    if (mapped.status === 'registered' || mapped.status === 'invalid') return true;
    var t = String(mapped.status_text || '');
    return (
      t === 'お客様登録' ||
      t === '番号登録済み（配達状況の反映待ち）' ||
      t === '配達状況の反映待ち' ||
      t === '配達状況の確認待ち' ||
      t === '追跡確認中' ||
      t === '追跡ページ確認可' ||
      t === '登録済み' ||
      t === '伝票番号未登録' ||
      t === '伝票番号をご確認ください' ||
      /誤り|確認して/.test(t)
    );
  }

  function isInvalidNumberText(raw) {
    var t = String(raw || '');
    return /伝票番号に誤り|伝票番号誤り|番号に誤り|誤りがあります|再度ご確認|ご確認の上|入力内容をご確認|お問い合わせ票番号に誤り/.test(t);
  }

  function dashedTracking(num) {
    var d = String(num || '').replace(/\D/g, '');
    if (d.length === 12) return d.replace(/(\d{4})(\d{4})(\d{4})/, '$1-$2-$3');
    return d;
  }

  /** ヤマト12桁の7DR。不一致なら公式と同じ「伝票番号誤り」 */
  function isYamatoCheckDigitInvalid(trackingNumber) {
    var d = String(trackingNumber || '').replace(/\D/g, '');
    if (d.length !== 12) return false;
    try {
      var rem = Number(BigInt(d.slice(0, 11)) % BigInt(7));
      return rem !== parseInt(d.charAt(11), 10);
    } catch (e) {
      return false;
    }
  }

  function yamatoResultScope(html, trackingNumber) {
    var raw = String(html || '');
    var num = String(trackingNumber || '').replace(/\D/g, '');
    var dashed = dashedTracking(num);
    var blocks = raw.match(/<div class="parts-tracking-invoice-block"[\s\S]*?(?=<div class="parts-tracking-invoice-block"|<div class="page-content-information"|$)/gi) || [];
    if (blocks.length) {
      for (var i = 0; i < blocks.length; i++) {
        if ((num && blocks[i].indexOf(num) !== -1) || (dashed && blocks[i].indexOf(dashed) !== -1)) return blocks[i];
      }
      return blocks[0];
    }
    var print = raw.match(/function PRINT_0\([\s\S]*?function PRINT_/);
    return print ? print[0] : raw;
  }

  function mapStatusFromText(raw, carrier) {
    var t = String(raw || '');
    if (isInvalidNumberText(t)) {
      return { status: 'invalid', office: '', status_text: '伝票番号をご確認ください' };
    }
    if (/伝票番号未登録/.test(t)) {
      return { status: 'registered', office: '', status_text: '配達状況の反映待ち' };
    }
    if (/配達完了|投函完了|お届け先にお届け済み|窓口でお渡し|配達済/.test(t)) {
      return { status: 'arrived', office: '', status_text: '到着' };
    }
    if (/到着/.test(t) && /営業所|作業店|センター|郵便局|局留/.test(t)) {
      return { status: 'office', office: '', status_text: '拠点到着' };
    }
    if (/営業所到着|作業店到着|センター到着|局留|保管中/.test(t)) {
      return { status: 'office', office: '', status_text: '拠点到着' };
    }
    if (/輸送中|配達中|配達途中|持出中|配達準備|運送中|発送済み/.test(t)) {
      return { status: 'in_transit', office: '', status_text: '輸送中' };
    }
    if (/荷物発送/.test(t) && !/荷物受付|引受|集荷|到着|配達完了/.test(t)) {
      return { status: 'in_transit', office: '', status_text: '輸送中' };
    }
    if (/集荷|受付|引受|お預かり|荷物受付|差し出し/.test(t)) {
      return { status: 'picked', office: '', status_text: '引受' };
    }
    if (/到着/.test(t) && !/到着予定/.test(t)) {
      return { status: 'arrived', office: '', status_text: '到着' };
    }
    return null;
  }

  async function fetchText(url) {
    var sources = [
      'https://r.jina.ai/' + url,
      'https://api.allorigins.win/raw?url=' + encodeURIComponent(url),
      'https://corsproxy.io/?' + encodeURIComponent(url)
    ];
    for (var i = 0; i < sources.length; i++) {
      try {
        var res = await fetch(sources[i], {
          method: 'GET',
          headers: { Accept: 'text/plain, text/html, */*' }
        });
        if (!res.ok) continue;
        var text = await res.text();
        if (text && text.length > 80) return text;
      } catch (e) {}
    }
    return '';
  }

  function normalizeOfficeName(name) {
    return String(name || '')
      .replace(/\s+/g, '')
      .replace(/ヤマト運輸/g, '')
      .trim();
  }

  function extractLatestOffice(plain) {
    var near = plain.match(
      /(?:輸送中|発送済み|発送|作業店通過|配達中|持出中|荷物受付|集荷)[\s　:：]{0,12}([一-龥ぁ-んァ-ヶA-Za-z0-9・\-（）()]{2,40}(?:営業所|センター|支店|作業店)(?:（[^）]{1,20}）)?)/
    );
    if (near) {
      var n0 = normalizeOfficeName(near[1]);
      if (n0 && !/サービスセンター|お客様|お問い合わせ/.test(n0)) return n0;
    }
    var re = /([一-龥ぁ-んァ-ヶA-Za-z0-9・\-（）()]{2,40}(?:営業所|センター|支店|作業店)(?:（[^）]{1,20}）)?)/g;
    var found = [];
    var m;
    while ((m = re.exec(plain))) {
      var n = normalizeOfficeName(m[1]);
      if (!n || /サービスセンター|お客様|お問い合わせ|法人営業本部/.test(n)) continue;
      if (found.indexOf(n) === -1) found.push(n);
    }
    return found.length ? found[0] : '';
  }

  function extractJapanPostOffice(plain) {
    var near = plain.match(
      /(?:引受|運送中|到着|配達中|保管)[\s　:：]{0,20}([一-龥ぁ-んァ-ヶA-Za-z0-9・\-（）()]{2,40}郵便局)/
    );
    if (near) return normalizeOfficeName(near[1]);
    var m = plain.match(/([一-龥ぁ-んァ-ヶA-Za-z0-9・\-（）()]{2,40}郵便局)/);
    return m ? normalizeOfficeName(m[1]) : '';
  }

  function extractStatus(htmlOrText, carrier, trackingNumber) {
    var raw = String(htmlOrText || '');
    var scopeHtml = carrier === 'yamato' ? yamatoResultScope(raw, trackingNumber || '') : raw;
    var plain = stripTags(scopeHtml);
    var fullPlain = stripTags(raw);
    if (carrier === 'yamato') {
      var stateTitle = ((scopeHtml.match(/tracking-invoice-block-state-title[^>]*>([^<]+)/i) || [])[1] || '').trim();
      var stateSummary = ((scopeHtml.match(/tracking-invoice-block-state-summary[^>]*>([^<]+)/i) || [])[1] || '').trim();
      var stateBlob = stateTitle + ' ' + stateSummary;
      if (/伝票番号誤り|誤りがあります/.test(stateBlob) || isInvalidNumberText(stateBlob) || isInvalidNumberText(plain)) {
        return { status: 'invalid', office: '', status_text: '伝票番号をご確認ください' };
      }
      if (/伝票番号未登録|まだ荷物情報が登録/.test(stateBlob) || /伝票番号未登録/.test(plain)) {
        return { status: 'registered', office: '', status_text: '配達状況の反映待ち' };
      }
    } else if (isInvalidNumberText(plain) || isInvalidNumberText(fullPlain)) {
      return { status: 'invalid', office: '', status_text: '伝票番号をご確認ください' };
    }
    if (/伝票番号未登録/.test(plain) || /伝票番号未登録/.test(fullPlain)) {
      return { status: 'registered', office: '', status_text: '配達状況の反映待ち' };
    }
    var patterns = carrier === 'japan_post'
      ? [
          /(お届け先にお届け済み|配達完了|配達済|引受|差し出し|運送中|配達中|到着|保管|持出中)/,
          /状態\s*[:：]?\s*([ぁ-んァ-ヶ一-龥A-Za-z0-9]{2,20})/,
          /履歴情報[\s\S]{0,120}?(引受|運送中|到着|お届け先にお届け済み|配達完了|保管)/
        ]
      : [
          /最新状況[^0-9A-Za-zぁ-んァ-ヶ一-龥]*([ぁ-んァ-ヶ一-龥A-Za-z0-9　\s]{2,40})/,
          /(配達完了|荷物受付|集荷|輸送中|配達中|営業所到着|作業店到着|センター到着|伝票番号未登録)/
        ];
    for (var i = 0; i < patterns.length; i++) {
      var m = plain.match(patterns[i]);
      if (!m) continue;
      var hit = (m[1] || m[0] || '').trim();
      if (hit === '伝票番号未登録') {
        return { status: 'registered', office: '', status_text: '配達状況の反映待ち' };
      }
      var mapped = mapStatusFromText(hit, carrier);
      if (!mapped) continue;
      var office = carrier === 'japan_post' ? extractJapanPostOffice(plain) : extractLatestOffice(plain);
      if (office) mapped.office = office;
      if (mapped.status === 'in_transit') {
        if (!office) return null;
        mapped.status_text = office + 'から輸送中';
      } else if (mapped.status === 'picked') {
        if (!office) return null;
        mapped.status_text = office;
      } else if (mapped.status === 'arrived') {
        if (!office) return null;
        mapped.status_text = office + '（到着）';
      } else if (mapped.status === 'office') {
        if (!office) return null;
        mapped.status_text = office;
      }
      return mapped;
    }
    if (carrier === 'yamato' && /tracking-invoice-block/.test(raw)) {
      return { status: 'registered', office: '', status_text: '配達状況の反映待ち' };
    }
    return null;
  }

  w.buybackYamatoSync = async function (body) {
    try {
      var res = await fetch(FN_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': SUPABASE_ANON_KEY,
          'Authorization': 'Bearer ' + SUPABASE_ANON_KEY
        },
        body: JSON.stringify(body || {})
      });
      if (!res.ok) return { configured: false, ok: false, status: res.status };
      return await res.json();
    } catch (e) {
      return { configured: false, ok: false };
    }
  };

  /** サーバ側POSTスクレイプ（ヤマトGET不可対策）→ 失敗時のみプロキシGET */
  async function scrapeViaEdge(trackingNumber, carrier, requestId) {
    var r = await w.buybackYamatoSync({
      action: 'scrape',
      request_id: requestId || 'scrape',
      tracking_number: trackingNumber,
      carrier: carrier
    });
    if (r && r.ok && r.mapped) return r.mapped;
    // poll でもサーバ側POST取得できる
    if (requestId) {
      var p = await w.buybackYamatoSync({
        action: 'poll',
        request_id: requestId,
        tracking_number: trackingNumber
      });
      if (p && p.mapped) return p.mapped;
      if (p && p.updated) return { __updated_by_edge: true };
    }
    return null;
  }

  async function fetchPublicYamato(trackingNumber, requestId) {
    var viaEdge = await scrapeViaEdge(trackingNumber, 'yamato', requestId);
    if (viaEdge) return viaEdge;
    // 最終手段（GETは空フォームになりやすいがプロキシ経路は残す）
    var url = 'https://toi.kuronekoyamato.co.jp/cgi-bin/tneko?number00=1&number01=' + encodeURIComponent(trackingNumber);
    var html = await fetchText(url);
    if (!html) return null;
    return extractStatus(html, 'yamato', trackingNumber);
  }

  async function fetchPublicJapanPost(trackingNumber, requestId) {
    var viaEdge = await scrapeViaEdge(trackingNumber, 'japan_post', requestId);
    if (viaEdge) return viaEdge;
    var url =
      'https://trackings.post.japanpost.jp/services/srv/search/direct?searchKind=S002&locale=ja&reqCodeNo1=' +
      encodeURIComponent(trackingNumber);
    var html = await fetchText(url);
    if (!html) return null;
    return extractStatus(html, 'japan_post', trackingNumber);
  }

  async function insertTracking(requestId, payload) {
    try {
      var res = await fetch(REST_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          apikey: SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + SUPABASE_ANON_KEY,
          Prefer: 'return=minimal'
        },
        body: JSON.stringify({
          request_id: requestId,
          sender_type: 'customer',
          content: '[YAMATO_TRACKING]:' + JSON.stringify(payload)
        })
      });
      return res.ok;
    } catch (e) {
      return false;
    }
  }

  async function readLatestTrackingScan(requestId) {
    try {
      var url = REST_URL +
        '?request_id=eq.' + encodeURIComponent(requestId) +
        '&select=content&order=created_at.asc';
      var res = await fetch(url, {
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: 'Bearer ' + SUPABASE_ANON_KEY
        }
      });
      if (!res.ok) return { track: null, carrier: '' };
      var rows = await res.json();
      var track = null;
      var carrier = '';
      (rows || []).forEach(function (row) {
        var c = String(row.content || '');
        if (c.indexOf('[CARRIER:') === 0) {
          carrier = c.replace('[CARRIER:', '').replace(']', '');
        }
        if (c.indexOf('[YAMATO_TRACKING]:') === 0) {
          try { track = JSON.parse(c.replace('[YAMATO_TRACKING]:', '')); } catch (e) {}
        }
      });
      if (track && track.carrier) carrier = track.carrier;
      return { track: track, carrier: carrier || 'yamato' };
    } catch (e) {
      return { track: null, carrier: '' };
    }
  }

  // 自動更新は停止（公式追跡リンクで確認する運用）
  w.startBuybackYamatoPoll = function () {
    w.stopBuybackYamatoPoll();
  };

  w.stopBuybackYamatoPoll = function () {
    if (pollTimer) clearInterval(pollTimer);
    pollTimer = null;
    pollRequestId = null;
    pollOnUpdated = null;
    runPollTick = null;
    tickBusy = false;
    failStreak = 0;
  };

  // --- ヤマト公式の最新追跡URL（毎回公式FAQ/トップから解決。追跡＝最新URL＋番号） ---
  var YAMATO_EP_CACHE_KEY = 'buyback_yamato_track_endpoint_v1';
  var YAMATO_EP_TTL_MS = 30 * 60 * 1000; // 30分（表示中の再取得間隔）
  var YAMATO_EP_RESOLVE_TIMEOUT_MS = 2500; // クリック時に最新取得を待つ上限
  var DEFAULT_YAMATO_TRACK_ENDPOINT = {
    action_url: 'https://toi.kuronekoyamato.co.jp/cgi-bin/tneko',
    method: 'POST',
    number_field: 'number01',
    count_field: 'number00',
    count_value: '1'
  };
  var yamatoEndpointMem = null;
  var yamatoEndpointRefreshPromise = null;

  function sanitizeYamatoEndpoint(raw) {
    var ep = raw && typeof raw === 'object' ? raw : {};
    var actionUrl = String(ep.action_url || '').trim();
    try {
      var u = new URL(actionUrl);
      var host = u.hostname.toLowerCase();
      if (host !== 'kuronekoyamato.co.jp' && host.indexOf('.kuronekoyamato.co.jp') === -1) {
        return null;
      }
      if (/member\.kms|FormPage|\/login|oauth|signin/i.test(u.href)) return null;
    } catch (e) {
      return null;
    }
    return {
      action_url: actionUrl.split('#')[0],
      method: String(ep.method || 'POST').toUpperCase() === 'GET' ? 'GET' : 'POST',
      number_field: String(ep.number_field || 'number01'),
      count_field: String(ep.count_field || 'number00'),
      count_value: String(ep.count_value != null ? ep.count_value : '1'),
      resolved_at: ep.resolved_at || null,
      source: ep.source || null
    };
  }

  function readYamatoEndpointCache() {
    try {
      var raw = localStorage.getItem(YAMATO_EP_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      var ep = sanitizeYamatoEndpoint(parsed && parsed.endpoint);
      if (!ep) return null;
      return { endpoint: ep, saved_at: Number(parsed.saved_at || 0) || 0 };
    } catch (e) {
      return null;
    }
  }

  function writeYamatoEndpointCache(endpoint) {
    var ep = sanitizeYamatoEndpoint(endpoint);
    if (!ep) return;
    yamatoEndpointMem = ep;
    try {
      localStorage.setItem(YAMATO_EP_CACHE_KEY, JSON.stringify({
        saved_at: Date.now(),
        endpoint: ep
      }));
    } catch (e) {}
  }

  w.getBuybackYamatoTrackEndpoint = function () {
    if (yamatoEndpointMem) return yamatoEndpointMem;
    var cached = readYamatoEndpointCache();
    if (cached && cached.endpoint) {
      yamatoEndpointMem = cached.endpoint;
      return cached.endpoint;
    }
    return DEFAULT_YAMATO_TRACK_ENDPOINT;
  };

  w.refreshBuybackYamatoTrackEndpoint = function (force) {
    if (!force) {
      var cached = readYamatoEndpointCache();
      if (cached && cached.endpoint && (Date.now() - cached.saved_at) < YAMATO_EP_TTL_MS) {
        yamatoEndpointMem = cached.endpoint;
        return Promise.resolve(cached.endpoint);
      }
    }
    if (yamatoEndpointRefreshPromise) return yamatoEndpointRefreshPromise;
    yamatoEndpointRefreshPromise = (async function () {
      try {
        var r = await w.buybackYamatoSync({ action: 'resolve_track_endpoint' });
        var ep = sanitizeYamatoEndpoint(r);
        if (ep) {
          writeYamatoEndpointCache(ep);
          return ep;
        }
      } catch (e) {}
      return w.getBuybackYamatoTrackEndpoint();
    })().finally(function () {
      yamatoEndpointRefreshPromise = null;
    });
    return yamatoEndpointRefreshPromise;
  };

  function submitYamatoTrackForm(ep, trackingNo, trackWin, winName) {
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = String((ep && ep.action_url) || DEFAULT_YAMATO_TRACK_ENDPOINT.action_url);
    form.target = trackWin ? winName : '_self';
    form.acceptCharset = 'UTF-8';
    form.style.display = 'none';
    if (ep && ep.count_field) {
      var n0 = document.createElement('input');
      n0.type = 'hidden';
      n0.name = String(ep.count_field);
      n0.value = String(ep.count_value != null ? ep.count_value : '1');
      form.appendChild(n0);
    }
    var n1 = document.createElement('input');
    n1.type = 'hidden';
    n1.name = String((ep && ep.number_field) || 'number01');
    n1.value = trackingNo;
    form.appendChild(n1);
    document.body.appendChild(form);
    if (String(n1.value || '').replace(/[^\d]/g, '') !== trackingNo) {
      try { form.remove(); } catch (err) {}
      return false;
    }
    form.submit();
    setTimeout(function () { try { form.remove(); } catch (err) {} }, 1500);
    return true;
  }

  /**
   * クリック時: 先にタブを開き → 公式の最新URLを強制取得 → 番号入りPOST。
   * 取得が遅いときだけキャッシュURLで開く（手入力させない）。
   */
  w.openBuybackYamatoTrackingOfficial = function (num) {
    var trackingNo = String(num || '').replace(/[^\d]/g, '');
    if (trackingNo.length < 11 || trackingNo.length > 13) {
      alert('追跡番号を確認できませんでした。もう一度登録内容をご確認ください。');
      return false;
    }
    var winName = 'buyback_yamato_track';
    var trackWin = null;
    try { trackWin = window.open('', winName); } catch (err) { trackWin = null; }
    if (!trackWin) {
      alert('新しいタブがブロックされたため、この画面でヤマトの追跡を開きます。');
    } else {
      try {
        trackWin.document.open();
        trackWin.document.write('<!doctype html><title>追跡準備中</title><body style="font-family:sans-serif;padding:24px;color:#334155;">ヤマト運輸の最新追跡ページを開いています…</body>');
        trackWin.document.close();
      } catch (err2) {}
    }

    var fallbackEp = w.getBuybackYamatoTrackEndpoint();
    var opened = false;
    function finish(ep) {
      if (opened) return;
      opened = true;
      var ok = submitYamatoTrackForm(ep || fallbackEp, trackingNo, trackWin, winName);
      if (!ok) {
        if (trackWin) { try { trackWin.close(); } catch (err3) {} }
        alert('追跡の開始に失敗しました。もう一度「配送状況を確認」を押してください。');
      }
    }

    var timedOut = false;
    var timer = setTimeout(function () {
      timedOut = true;
      finish(fallbackEp);
    }, YAMATO_EP_RESOLVE_TIMEOUT_MS);

    Promise.resolve(w.refreshBuybackYamatoTrackEndpoint(true)).then(function (ep) {
      clearTimeout(timer);
      if (timedOut) {
        // すでにキャッシュで開いた後でも、次回用に最新は保存済み
        return;
      }
      finish(ep || fallbackEp);
    }).catch(function () {
      clearTimeout(timer);
      if (!timedOut) finish(fallbackEp);
    });
    return true;
  };

  // --- 日本郵便公式の最新追跡URL（クリック時のみ解決。追跡＝最新URL＋番号） ---
  var JP_EP_CACHE_KEY = 'buyback_japan_post_track_endpoint_v1';
  var JP_EP_RESOLVE_TIMEOUT_MS = 2500;
  var DEFAULT_JAPAN_POST_TRACK_ENDPOINT = {
    action_url: 'https://trackings.post.japanpost.jp/services/srv/search/direct',
    method: 'GET',
    number_field: 'reqCodeNo1',
    search_kind: 'S002',
    locale: 'ja'
  };
  var japanPostEndpointMem = null;
  var japanPostEndpointRefreshPromise = null;

  function sanitizeJapanPostEndpoint(raw) {
    var ep = raw && typeof raw === 'object' ? raw : {};
    var actionUrl = String(ep.action_url || '').trim();
    try {
      var u = new URL(actionUrl);
      var host = u.hostname.toLowerCase();
      if (
        host !== 'post.japanpost.jp' &&
        host.indexOf('.post.japanpost.jp') === -1 &&
        host.indexOf('.japanpost.jp') === -1
      ) {
        return null;
      }
      if (/login|oauth|signin|firstDeliveryInput/i.test(u.href)) return null;
    } catch (e) {
      return null;
    }
    return {
      action_url: actionUrl.split('#')[0],
      method: String(ep.method || 'GET').toUpperCase() === 'POST' ? 'POST' : 'GET',
      number_field: String(ep.number_field || 'reqCodeNo1'),
      search_kind: String(ep.search_kind || ''),
      locale: String(ep.locale || 'ja'),
      resolved_at: ep.resolved_at || null,
      source: ep.source || null
    };
  }

  function readJapanPostEndpointCache() {
    try {
      var raw = localStorage.getItem(JP_EP_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      var ep = sanitizeJapanPostEndpoint(parsed && parsed.endpoint);
      if (!ep) return null;
      return { endpoint: ep, saved_at: Number(parsed.saved_at || 0) || 0 };
    } catch (e) {
      return null;
    }
  }

  function writeJapanPostEndpointCache(endpoint) {
    var ep = sanitizeJapanPostEndpoint(endpoint);
    if (!ep) return;
    japanPostEndpointMem = ep;
    try {
      localStorage.setItem(JP_EP_CACHE_KEY, JSON.stringify({
        saved_at: Date.now(),
        endpoint: ep
      }));
    } catch (e) {}
  }

  w.getBuybackJapanPostTrackEndpoint = function () {
    if (japanPostEndpointMem) return japanPostEndpointMem;
    var cached = readJapanPostEndpointCache();
    if (cached && cached.endpoint) {
      japanPostEndpointMem = cached.endpoint;
      return cached.endpoint;
    }
    return DEFAULT_JAPAN_POST_TRACK_ENDPOINT;
  };

  w.refreshBuybackJapanPostTrackEndpoint = function (force) {
    if (japanPostEndpointRefreshPromise) return japanPostEndpointRefreshPromise;
    japanPostEndpointRefreshPromise = (async function () {
      try {
        var r = await w.buybackYamatoSync({
          action: 'resolve_track_endpoint',
          carrier: 'japan_post'
        });
        var ep = sanitizeJapanPostEndpoint(r);
        if (ep) {
          writeJapanPostEndpointCache(ep);
          return ep;
        }
      } catch (e) {}
      return w.getBuybackJapanPostTrackEndpoint();
    })().finally(function () {
      japanPostEndpointRefreshPromise = null;
    });
    return japanPostEndpointRefreshPromise;
  };

  function buildJapanPostTrackUrl(ep, trackingNo) {
    var base = String((ep && ep.action_url) || DEFAULT_JAPAN_POST_TRACK_ENDPOINT.action_url).split('?')[0];
    var field = String((ep && ep.number_field) || 'reqCodeNo1');
    var params = new URLSearchParams();
    if (ep && ep.search_kind) params.set('searchKind', String(ep.search_kind));
    else if (/\/direct$/i.test(base) || field === 'reqCodeNo1') params.set('searchKind', 'S002');
    if (ep && ep.locale) params.set('locale', String(ep.locale));
    else params.set('locale', 'ja');
    params.set(field, trackingNo);
    return base + '?' + params.toString();
  }

  function openJapanPostTrackWithEndpoint(ep, trackingNo, trackWin, winName) {
    var url = buildJapanPostTrackUrl(ep, trackingNo);
    if (trackWin) {
      try {
        trackWin.location.href = url;
        return true;
      } catch (err) {}
    }
    try {
      var form = document.createElement('form');
      form.method = String((ep && ep.method) || 'GET').toUpperCase() === 'POST' ? 'POST' : 'GET';
      form.action = String((ep && ep.action_url) || DEFAULT_JAPAN_POST_TRACK_ENDPOINT.action_url).split('?')[0];
      form.target = trackWin ? winName : '_self';
      form.style.display = 'none';
      function addHidden(name, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        form.appendChild(input);
      }
      if (ep && ep.search_kind) addHidden('searchKind', String(ep.search_kind));
      else if (/\/direct$/i.test(form.action) || String((ep && ep.number_field) || '') === 'reqCodeNo1') {
        addHidden('searchKind', 'S002');
      }
      addHidden('locale', String((ep && ep.locale) || 'ja'));
      addHidden(String((ep && ep.number_field) || 'reqCodeNo1'), trackingNo);
      document.body.appendChild(form);
      form.submit();
      setTimeout(function () { try { form.remove(); } catch (err2) {} }, 1500);
      return true;
    } catch (err3) {
      if (!trackWin) window.location.href = url;
      else try { trackWin.location.href = url; } catch (err4) { return false; }
      return true;
    }
  }

  /**
   * クリック時のみ: 最新公式URL取得 → 番号入りで日本郵便追跡を開く
   */
  w.openBuybackJapanPostTrackingOfficial = function (num) {
    var trackingNo = String(num || '').replace(/[^\d]/g, '');
    if (trackingNo.length < 11 || trackingNo.length > 13) {
      alert('追跡番号を確認できませんでした。もう一度登録内容をご確認ください。');
      return false;
    }
    var winName = 'buyback_japan_post_track';
    var trackWin = null;
    try { trackWin = window.open('', winName); } catch (err) { trackWin = null; }
    if (!trackWin) {
      alert('新しいタブがブロックされたため、この画面で日本郵便の追跡を開きます。');
    } else {
      try {
        trackWin.document.open();
        trackWin.document.write('<!doctype html><title>追跡準備中</title><body style="font-family:sans-serif;padding:24px;color:#334155;">日本郵便の最新追跡ページを開いています…</body>');
        trackWin.document.close();
      } catch (err2) {}
    }

    var fallbackEp = w.getBuybackJapanPostTrackEndpoint();
    var opened = false;
    function finish(ep) {
      if (opened) return;
      opened = true;
      var ok = openJapanPostTrackWithEndpoint(ep || fallbackEp, trackingNo, trackWin, winName);
      if (!ok) {
        if (trackWin) { try { trackWin.close(); } catch (err3) {} }
        alert('追跡の開始に失敗しました。もう一度「配送状況を確認」を押してください。');
      }
    }

    var timedOut = false;
    var timer = setTimeout(function () {
      timedOut = true;
      finish(fallbackEp);
    }, JP_EP_RESOLVE_TIMEOUT_MS);

    Promise.resolve(w.refreshBuybackJapanPostTrackEndpoint(true)).then(function (ep) {
      clearTimeout(timer);
      if (timedOut) return;
      finish(ep || fallbackEp);
    }).catch(function () {
      clearTimeout(timer);
      if (!timedOut) finish(fallbackEp);
    });
    return true;
  };
})(window);
